import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=29240bb1&scoped=true&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"
import style0 from "./Comments.vue?vue&type=style&index=0&id=29240bb1&prod&lang=scss&scoped=true&"
import style1 from "./Comments.vue?vue&type=style&index=1&id=29240bb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29240bb1",
  null
  
)

export default component.exports